export default "__VITE_ASSET__BfiMKrPo__"